import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M.583 16V0l13 8.229L.583 16z" fill="#000" /></svg>;